import { render, staticRenderFns } from "./ReservationModal.vue?vue&type=template&id=96664db4&scoped=true"
import script from "./ReservationModal.vue?vue&type=script&lang=js"
export * from "./ReservationModal.vue?vue&type=script&lang=js"
import style0 from "./ReservationModal.vue?vue&type=style&index=0&id=96664db4&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "96664db4",
  null
  
)

export default component.exports